import { Pipe, PipeTransform } from '@angular/core';
import { PartnerCalculationModelEnum } from 'src/app/api/models/OK/Egis/Service/Models/Entities/Enums/partner-calculation-model-enum';
@Pipe({
    name: 'partnerCalculationModel',
    standalone: false
})
export class PartnerCalculationModelPipe implements PipeTransform {
  transform(value: PartnerCalculationModelEnum) {
    switch (value) {
      case PartnerCalculationModelEnum.PercentageCut:
        return 'Procentvis andel til s-partner';
      case PartnerCalculationModelEnum.VarenrOnServiceabonnement:
        return 'Fast afregningspris til s-partner';
      case PartnerCalculationModelEnum.PartnerDeterminedPrice:
        return 'Partnerbestemt pris til s-partner';
    }
    return value;
  }
}
